module.exports = __webpack_public_path__ + "img/d.ade3d07b.svg";